import IconEnum from '@/utilities/weather/services/openWeatherApi/enums/IconEnum'

export default class OpenWeatherIcon {
  private readonly icon: keyof typeof IconEnum

  constructor(icon: string) {
    this.icon = icon as keyof typeof IconEnum
  }

  getIcon(): string {
    return `${IconEnum[this.icon] ?? 'clear-day'}.png`
  }
}
